import styled, { css } from "styled-components";
import { InsertEmoticon, Archive } from "@material-ui/icons";
import { TextField, Avatar, Paper, IconButton } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { AiOutlineUpload } from "react-icons/ai";
import Picker from "emoji-picker-react";

export const Main = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 160px);
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 0px;
  margin: 0px 10px;
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vh - 140px);
  display: flex;
  flex-direction: column;
`;

export const ContactBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: #444444;
`;

export const ContactAvatar = styled(Avatar)`
  width: 42px;
  height: 42px;
  margin: 0px 10px;
  cursor: pointer;
`;

export const InfoSection = styled.div`
  display: flex;
  align-items: center;
`;

export const InfoSectionLoading = styled.p``;

export const CurrentContactInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AnimatedContent = styled.div``;

export const ContactName = styled.p``;

export const WhatsappStatus = styled.span``;

export const ContactInfoIcon = styled(InfoOutlinedIcon)`
  color: #444;
  font-size: 34px;
`;

export const StatusBar = styled.div`
  padding: 16px 16px 16px 42px;
  text-align: center;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  background: #eba1a1;
  position: relative;

  button {
    width: auto;
    float: right;
  }
`;

export const ArchivedContact = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ReOpenButtonTitle = styled.span``;

export const StatusBarSnoozed = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background-color: #f7f7f7;
`;

export const StatusInfoBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background-color: #f7f7f7;
  font-size: 18px;
  font-weight: bold;
`;

export const ButtonSnoozed = styled.button`
  background-color: #3d9be9;
  padding: 10px;
  color: #fff;
  font-weight: bold;
  border-radius: 10px;
  border: solid 2px #3d9be9;

  :hover {
    cursor: pointer;
  }

  :active {
    opacity: 0.5;
    background-color: #449be9;
    box-shadow: 0 1px #666;
    transform: translateY(2px);
  }
`;

export const ArchiveIcon = styled(Archive)``;

export const ContactInfo = styled.div`
  cursor: pointer;
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: baseline;
  align-items: center;
  justify-content: space-between;

  p {
    font-size: 18px;
  }

  .available {
    font-size: 11px;
    color: #16a257;
  }

  .unavailable {
    font-size: 11px;
    color: var(--c2s-red);
  }
`;

export const Form = styled.form`
  position: relative;
  min-height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 5;
  background: #efefef;
  box-sizing: border-box;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);
  padding: 8px;

  .send-message-container {
    min-height: 55px;
    width: 100%;
    margin-left: 16px;
    margin-right: 16px;
    border-radius: 24px;
    padding-left: 16px;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const SendMessageContainer = styled(Paper).attrs({
  className: "send-message-container",
  elevation: 1,
})``;

export const SendMessageField = styled(TextField)``;

export const EmojiPickerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
  padding: 5px;
  border-radius: 2%;

  position: relative;

  &:hover {
    transition: 500ms;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 50%;
  }
`;

export const EmojiPickerButton = styled(InsertEmoticon)`
  color: rgba(0, 0, 0, 0.8);
  cursor: pointer;
`;

export const EmojiPicker = styled(Picker).attrs({
  pickerStyle: {
    width: 440,
    padding: 10,
    border: "solid",
    borderWidth: 1,
    borderColor: "#d3d3d3",
    position: "absolute",
    bottom: 45,
    right: 0,
  },
})``;

export const ResponseContainer = styled.div`
  position: absolute;
  width: 100%;
  min-height: 60px;
  bottom: 65px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background: #efefef;
  box-sizing: border-box;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);
  padding: 8px;
  z-index: 2;
  transform: translateY(60px);

  .animated {
    background: #efefef;
    height: 68px;
    padding: 4px;
    width: 100%;
    position: absolute;
    display: flex;
    justify-content: space-around;
    align-items: center;
    bottom: -5px;
    visibility: hidden;
    transition: 0.3s;
  }

  .active {
    visibility: visible;
    bottom: 60px;
  }
`;

export const SendButton = styled(IconButton)``;

export const CloseButton = styled(IconButton)``;

export const UploadMenu = styled.div`
  visibility: hidden;
  position: absolute;
  opacity: 0;
  bottom: 50px;
  right: 58px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-evenly;
  height: 14rem;
  width: 4rem;

  transition: opacity 0.5s ease-in;

  background: rgba(155, 155, 155, 0.2);
  box-shadow: 0 8px 32px 0 rgba(155, 155, 155, 0.37);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 32px;
  border: 1px solid rgba(255, 255, 255, 0.28);

  ${(props) =>
    props.isOpen &&
    css`
      visibility: visible;
      opacity: 1;
    `};
`;

export const UploadButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 7px;
  padding: 5px;
  border-radius: 2%;

  position: relative;
  cursor: pointer;

  &:hover {
    transition: 500ms;
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 50%;
  }
`;
export const UploadIcon = styled(AiOutlineUpload).attrs({
  size: 24,
})``;
